import { useMemo } from "react";
import clsx from "clsx";

import { TextTooltip } from "@transfr-inc/dashboard-components";
import { getContentTypeIconById } from "@transfr-inc/dashboard-components/curriculum";
import "./column-header-course-tooltip.scss";

export function ColumnHeaderCourseTooltip({
  className,
  position,
  headerTitle,
  type,
  mimeType,
  tooltipText,
}) {
  const icon = useMemo(
    () => getContentTypeIconById(type, mimeType),
    [type, mimeType],
  );

  return (
    <TextTooltip text={tooltipText} position={position}>
      <div className={clsx("course-header", className)}>
        {icon}
        <span className="course-header-text">{headerTitle}</span>
      </div>
    </TextTooltip>
  );
}
